module.exports = __webpack_public_path__ + "img/gps1.8d835f4b.png";